import { useContext, useMemo } from 'react'
import { AlbumsApiContext, AlbumsContext } from './AlbumsContext'

export const useAlbums = () => {
  const { selectedAlbum, ...context } = useContext(AlbumsContext)

  // albumMemoryCount is a separate variable so that emptyAlbum will check for an empty album when the count changes
  const albumMemoryCount = selectedAlbum?.artifactCount
  const emptyAlbum = useMemo(() => selectedAlbum && albumMemoryCount === 0, [albumMemoryCount, selectedAlbum])

  return { albumMemoryCount, emptyAlbum, selectedAlbum, ...context }
}

export const useAlbumsApi = () => useContext(AlbumsApiContext)
